module.exports = __webpack_public_path__ + "img/plan1.f497783b.svg";